import { setHtml, makeText } from './lib.js';
import { hideLoading, showLoading } from './utils-module.js';
import { initLoc, setTextToElement, t } from './localization.js';
import { getFaqContentHtml } from '../localization/htmlContent.js';
import { pageRoutes } from './page-routes.js';

init();

async function init() {
  showLoading();
  await initLoc();
  const faqContentHtml = await getFaqContentHtml();
  if (!faqContentHtml.trim()) {
    window.location.href = localStorage.getItem('home') || pageRoutes.index;
    return;
  }
  setTextToElement('.top-panel__menu-text', t('title-faq'));
  const content = makeText('.html-content');
  setHtml(faqContentHtml, content);
  hideLoading();
}
